<template>
  <span v-if="isDoneTrack(gpsTrack)" va-b-tooltip.hover :title="$t('doneTrack')">
    <img  :style="{height: height + 'px'}" :src="icons.calendarCheck" />
  </span>
  <span v-else-if="isPlannedTrack(gpsTrack)" va-b-tooltip.hover :title="$t('plannedTrack')">
    <img  :style="{height: height + 'px'}" :src="icons.calendarTimes" />
  </span>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import GpsTrack from '@/ts/GpsTrack';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    props: {
        gpsTrack: { required: true,
            type: Object as PropType<GpsTrack>
        },
        height: { required: true,
            type: null as PropType<number | string>
        }
    }
})

</script>
